import type { IconNode } from '../types';

/**
 * @name ironing-board
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNiAzYTQgNCAwIDAgMCAwIDhoMTRhMiAyIDAgMCAwIDItMlY1YTIgMiAwIDAgMC0yLTJaIiAvPgogIDxwYXRoIGQ9Im02IDIxIDEyLTEwIiAvPgogIDxwYXRoIGQ9Im02IDExIDEyIDEwIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/ironing-board
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const ironingBoard: IconNode = [
  ['path', { d: 'M6 3a4 4 0 0 0 0 8h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z', key: '10d6v9' }],
  ['path', { d: 'm6 21 12-10', key: '13nua5' }],
  ['path', { d: 'm6 11 12 10', key: '1605xv' }],
];

export default ironingBoard;
